<div class="modal-header c-modal__header" *ngIf="!config?.HideHeader">
  <button
      *ngIf="!config?.HideClose"
      type="button"
      class="close"
      (click)="closeModal(false)">
    &times;
  </button>
  <h4 class="modal-title c-modal__title" *ngIf="config?.Title">{{ config?.Title }}</h4>
</div>
<div class="modal-body c-modal__body">
  <ng-container #bodyContainer></ng-container>
</div>
<div class="modal-footer">
  <ng-container #footerContainer></ng-container>
</div>
